import { selectChangeMessageForPreviousVersionItems } from '@UI/aside/asidePreviousVersionItems/AsidePreviousVersionItemsSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectGoalSubItem } from '@newStore/documentUI/transformContent/llinkidSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { llinkidDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const LLINKID_PEDAGOGICAL_TIP: BuildingBlockNodeConfig = {
  nodeSelector: selectGoalSubItem,
  information: {
    single: 'Wenk',
    plural: 'Wenken',
  },

  buildingBlocks: [{ type: NodeType.LLINKID_CONCRETIZATION }],
  edit: [
    llinkidDescriptionComponent,
    {
      component: 'previousVersionItems',
      reactComponent: 'AsidePreviousVersionItems',
      label: 'Vervangt (uit vorige versie)',
      options: {
        relationTypes: ['REPLACES'],
        modal: 'llinkidPreviousVersionModal',
        modalTitle: 'Vervangt (uit vorige versie)',
        listColumn: 'description',
        placeholder: 'Kies een te vervangen wenk',
        relation: 'Wenk',
        errorMessage: 'Je moet een geldige wenk selecteren',
        type: ContentType.LLINKID_PEDAGOGICAL_TIP,
      },
      asideChangeMessageSelector: selectChangeMessageForPreviousVersionItems,
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'description',
  },
};

export default LLINKID_PEDAGOGICAL_TIP;
